import { render, staticRenderFns } from "./document-tags-select.vue?vue&type=template&id=3ef29044"
import script from "./document-tags-select.vue?vue&type=script&lang=js"
export * from "./document-tags-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports